<template lang="pug">
    #modal-upload-planilha-erro-detalhes
        el-dialog(
            append-to-body,
            title='Erro ao carregar polígono',
            width='680px',
            top='30vh !important',
            :visible.sync='abrirModal',
            @close='fecharModal()'
        )
            p.text {{ $t('mensagens.menuMapa.planilha.observacoes.erro.7') }}
                |
                | <br>{{ $t('mensagens.menuMapa.planilha.observacoes.erro.8') }}

            p.text(v-for='erro in this.poligonosErros')
                b {{ erro.sheetName }}
                |
                |<br/> {{ erro.erroLinha }}
            BaseButton(
              slot='footer',
              size='mini',
              type='primary',
              @click='fecharModal()') {{ $t('mensagens.comuns.fechar') }}
</template>

<script>
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
export default {
    name: 'ModalUploadPlanilhaErroDetalhes',
    components: {
        BaseButton
    },
    emits: ['fecharModal'],
    props: {
        abrirModal: {
            type: Boolean,
            required: true
        },
      poligonosErros: {
        type: Array,
        required: false,
        default: () => []
      }
    },
    methods: {
        fecharModal() {
            this.$emit('fecharModal');
        }
    }
};
</script>
